import axios from 'axios';

export const getShofifyToken = async (id: any, email: any) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const url = `${apiUrl}/api/v1/auth/user?id=${id}&email=${email}`;

  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    console.error("Error fetching data!", error);
    return axios.isAxiosError(error) && error.response ? error.response : null;
  }
};
